import { AppLayout } from "@/pages/common/AppLayout/AppLayout"
import { NotFound } from "@/pages/common/NotFound/index.page"
import { RouteObject, createBrowserRouter } from "react-router-dom"
import { ALL_ROUTES, PAGE_TITLES, getTitleFromPath } from "@/utils/constants"

// Re-export for convenience
export { ALL_ROUTES, PAGE_TITLES, getTitleFromPath }

// Wraps a lazy route import and re-throws any error so React Router's errorElement handles it
async function lazyRoute<T extends Record<string, React.ComponentType>>(
   factory: () => Promise<T>,
   key: keyof T
): Promise<{ Component: React.ComponentType }> {
   const mod = await factory()
   return { Component: mod[key] }
}

function RouteErrorFallback() {
  //TODO: ADD SENTRY

   return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-5 p-xl text-center">
         <h2 className="text-body font-semibold">Si è verificato un errore nel caricamento della pagina.</h2>
         <button
            className="rounded-full bg-primary px-lg py-md font-button text-button text-accent p-5"
            onClick={() => window.location.reload()}
         >
            Ricarica
         </button>
      </div>
   )
}

export const globalRoutes: RouteObject[] = [
   {
      element: <AppLayout />,
      errorElement: <RouteErrorFallback />,
      children: [
         {
            path: ALL_ROUTES.basePath,
            lazy: () => lazyRoute(() => import("../pages/Home/index.page"), "HomePage"),
            HydrateFallback: () => <div>Loading...</div>
         },
         {
            path: ALL_ROUTES.room,
            lazy: () => lazyRoute(() => import("../pages/RoomDetail/index.page"), "RoomDetailPage"),
            HydrateFallback: () => <div>Loading...</div>
         },
         {
            path: ALL_ROUTES.rooms,
            lazy: () => lazyRoute(() => import("../pages/Rooms/index.page"), "RoomsPage"),
            HydrateFallback: () => <div>Loading...</div>
         },
         {
            path: ALL_ROUTES.artwork,
            lazy: () => lazyRoute(() => import("../pages/ArtworkDetailPage/index.page"), "ArtworkDetailPage"),
            HydrateFallback: () => <div>Loading...</div>
         },
         {
            path: ALL_ROUTES.feed,
            lazy: () => lazyRoute(() => import("../pages/FeedDetailPage/index.page"), "FeedDetailPage"),
            HydrateFallback: () => <div>Loading...</div>
         },
         {
            path: ALL_ROUTES.map,
            lazy: () => lazyRoute(() => import("../pages/MapPage/index.page"), "MapPage"),
            HydrateFallback: () => <div>Loading...</div>
         },
         {
            path: ALL_ROUTES.info,
            lazy: () => lazyRoute(() => import("../pages/Info/index.page"), "InfoPage"),
            HydrateFallback: () => <div>Loading...</div>
         },
         {
            path: ALL_ROUTES.quiz,
            lazy: () => lazyRoute(() => import("../pages/QuizSelection/index.page"), "QuizSelectionPage"),
            HydrateFallback: () => <div>Loading...</div>
         },
         {
            path: ALL_ROUTES.stepQuiz,
            lazy: () => lazyRoute(() => import("../pages/QuizGame/index.page"), "QuizGamePage"),
            HydrateFallback: () => <div>Loading...</div>
         },
         {
            path: ALL_ROUTES.endRoom,
            lazy: () => lazyRoute(() => import("../pages/EndTourPage/index.page"), "EndTourPage"),
            HydrateFallback: () => <div>Loading...</div>
         },
         {
            path: ALL_ROUTES.accessibility,
            lazy: () => lazyRoute(() => import("../pages/Accessibility/index.page"), "AccessibilityPage"),
            HydrateFallback: () => <div>Loading...</div>
         },
         {
           path: "*",
           element: <NotFound />
          },
          {
           ...!import.meta.env.DEV ? null :
             {
                path: ALL_ROUTES.test,
                // lazy: async () => { throw new Error("Simulazione errore chunk") },

                lazy: () => lazyRoute(() => import("../pages/Test/TestDataLayer"), "TestDataLayer"),
                HydrateFallback: () => <div>Loading...</div>
             }
          },
          // {
          //   path: ALL_ROUTES.test2,
          //   async lazy() {
          //      let { AccessibilityTest } = await import("../pages/Test/AccessibilityTest")
          //      return { Component: AccessibilityTest }
          //   },
          //   HydrateFallback: () => <div>Loading...</div>
          // },
      ]
   }
]

export const Router = createBrowserRouter(globalRoutes, {
  future: {
    v7_partialHydration: true,
  },
})
